import { MenuBook } from '@mui/icons-material';
import { guard } from '../RequirePermission';
import { PlaybookList } from './PlaybookList';
import { PlaybookShow } from './PlaybookShow';
import { PlaybookCreate } from './PlaybookCreate';
import { PlaybookEdit } from './PlaybookEdit';

export { PromoteToPlaybookButton } from './PromoteToPlaybookButton';
export type { PromotableInvestigation } from './PromoteToPlaybookButton';

// All four screens gated by the P2 management permission (REF-03 s.5). guard wraps each in
// <RequirePermission permission="ai_troubleshooting:manage:all">, which renders <AccessDeniedPage>
// if the actor lacks it (and honors *:*:* via hasPermission) — so even a hand-typed
// #/ai-playbooks URL is access-gated.
const PERM = 'ai_troubleshooting:manage:all';

export const aiPlaybooksResource = {
  list: guard(PERM, PlaybookList),
  show: guard(PERM, PlaybookShow),
  edit: guard(PERM, PlaybookEdit),
  create: guard(PERM, PlaybookCreate),
  icon: MenuBook,
  recordRepresentation: 'name',
};
